<template>
  <v-card elevation="2">
    <v-toolbar color="indigo darken-2" dark flat>
      <v-icon left>mdi-chart-box</v-icon>
      <v-toolbar-title>Reports & Documents</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-card outlined hover @click="$emit('generate-report', 'statement')">
            <v-card-text class="text-center">
              <v-icon size="48" color="blue">mdi-file-document</v-icon>
              <div class="text-h6 mt-2">Statement</div>
              <div class="text-caption grey--text">
                Generate account statement
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card outlined hover @click="$emit('generate-report', 'receipt')">
            <v-card-text class="text-center">
              <v-icon size="48" color="green">mdi-receipt</v-icon>
              <div class="text-h6 mt-2">Receipt</div>
              <div class="text-caption grey--text">
                Generate payment receipt
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card outlined hover @click="$emit('generate-report', 'report')">
            <v-card-text class="text-center">
              <v-icon size="48" color="purple">mdi-file-chart</v-icon>
              <div class="text-h6 mt-2">Client Report</div>
              <div class="text-caption grey--text">Full client overview</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card outlined hover @click="$emit('export-excel')">
            <v-card-text class="text-center">
              <v-icon size="48" color="teal">mdi-file-excel</v-icon>
              <div class="text-h6 mt-2">Export to Excel</div>
              <div class="text-caption grey--text">Download client data</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" v-if="showIndustryReport">
          <v-card outlined hover @click="$emit('generate-industry-report')">
            <v-card-text class="text-center">
              <v-icon size="48" color="orange">{{ industryIcon }}</v-icon>
              <div class="text-h6 mt-2">{{ industryReportLabel }}</div>
              <div class="text-caption grey--text">
                Industry-specific report
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card outlined hover @click="$emit('print-summary')">
            <v-card-text class="text-center">
              <v-icon size="48" color="red">mdi-printer</v-icon>
              <div class="text-h6 mt-2">Print Summary</div>
              <div class="text-caption grey--text">Quick print overview</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ReportsSection",

  props: {
    industry: {
      type: String,
      default: "General",
    },
  },

  computed: {
    showIndustryReport() {
      return this.industry !== "General";
    },

    industryReportLabel() {
      const labels = {
        "Legal Practice": "Case Summary",
        "Private Health": "Medical History",
        Mechanics: "Service Report",
      };

      return labels[this.industry] || "Report";
    },

    industryIcon() {
      const icons = {
        "Legal Practice": "mdi-gavel",
        "Private Health": "mdi-medical-bag",
        Mechanics: "mdi-car-wrench",
      };

      return icons[this.industry] || "mdi-file";
    },
  },
};
</script>

<style scoped>
.v-card:hover {
  cursor: pointer;
  transform: translateY(-2px);
  transition: all 0.2s ease;
}
</style>
